import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormGroup } from '@angular/forms';
import { TicketService, TicketDTO } from 'ticket-sdk';
import { AuthenticationService } from '@app/core/services/authentication.service';
import { ModalController, ToastController, Platform, AlertController } from '@ionic/angular';
import { UpdateLicensePlateNumberPage } from './update-license-plate-number/update-license-plate-number.page';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { environment } from '@env';

@Component({
  selector: 'app-tickets',
  templateUrl: './tickets.page.html',
  styleUrls: ['./tickets.page.scss'],
})
export class TicketsPage implements OnInit {
  isAuthenticated: Observable<boolean>;
  loading: boolean = false;
  refreshing: boolean = false;
  tickets: TicketDTO[] = [];

  constructor(
    public fb: UntypedFormBuilder,
    private authenticationService: AuthenticationService,
    private ticketService: TicketService,
    private modalController: ModalController,
    public toastController: ToastController,
    public platform: Platform,
    private router: Router,
    private alertController: AlertController
  ) { }

  get isMobile() {
    return this.platform.is('mobile');
  }

  get isProd(): boolean {
    return environment.production;
  }

  ngOnInit() {
    this.isAuthenticated = this.authenticationService.authenticationState;
  }

  ionViewWillEnter() {
    this.getTickets();
  }

  getTickets() {
    this.loading = true;
    this.ticketService.getUserTickets()
    .pipe(take(1))
    .subscribe(
      tickets => this.tickets = tickets.sort((t1, t2) => t2.createdDate.getTime() - t1.createdDate.getTime()),
      error => {
        if (error.status === 0) {
          this.presentFetchDataErrorToast('Kontrollera din internetanslutning och försök igen');
        }
        else {
          this.presentFetchDataErrorToast();
        }
      }
    )
    .add(() => {
      this.loading = false;
      this.refreshing = false;
    });    
  }

  goToBuyTicket() {
    this.router.navigateByUrl('buy-ticket');
  }

  async openChangeLicensePlateNumberModal(ticket: TicketDTO) {
    const modal = await this.modalController.create({
      component: UpdateLicensePlateNumberPage,
      keyboardClose: false,
      cssClass: 'change-lpn-modal',
      componentProps: {
        ticket: ticket,
        isMobile: this.isMobile
      }
    });

    await modal.present();

    const { data } = await modal.onWillDismiss();
    
    if (data) {
      this.ticketService.getUserTickets()
      .pipe(take(1))
      .subscribe(tickets => {
        this.tickets = tickets;
      });
    }
  }

  async presentFetchDataErrorToast(message?: string) {
    message = message || 'Ett okänt fel uppstod. Prova igen om en liten stund';

    const toast = await this.toastController.create({
      message,
      color: 'danger',
      position: 'top',
      duration: 5000
    });
    toast.present();
  }

  refreshTickets() {
    this.refreshing = true;
    this.tickets = [];

    setTimeout(() => {
      this.getTickets();
    }, 1000)
  }

  async updateLicensePlateNumber(ticket: TicketDTO) {
    const alert = await this.alertController.create({
      header: 'Observera',
      message: 'Registreringsnumret på biljetten ändras direkt efter att du har bekräftat bytet. Därefter kan du inte byta det igen förr än tidigast nästkommande dygn.',
      buttons: [
        {
          text: 'Avbryt',
          role: 'cancel'
        },
        {
          text: 'Fortsätt',
          handler: () => this.openChangeLicensePlateNumberModal(ticket)
        }
      ]
    });

    await alert.present();
  }
}
